import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import NerdCorner from "@/components/NerdCorner";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetail from "@/pages/ProductDetail";
import NerdVault from "@/pages/NerdVault";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
      <CartProvider>
        <BrowserRouter>
          <CartDrawer />
          <NerdCorner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Catalogue />} />
            <Route path="/nerd" element={<NerdVault />} />
            <Route path="/product/:id" element={<ProductDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "0",
              color: "#f2f2f2",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "12px",
            },
          }}
        />
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
